module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/faq-ico-000d2b6d1ff6b5045e37513ede2a3683.svg";